import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App.tsx";
import { APP_TITLE } from "./lib/constants";
import { initPwaInstallCapture } from "./lib/pwaInstall";
import "./index.css";

document.title = APP_TITLE;
initPwaInstallCapture();

if (import.meta.env.DEV) {
  const badge = document.createElement("div");
  badge.textContent = "Vite dev";
  badge.setAttribute("data-ownerflow-vite", "1");
  badge.style.cssText =
    "position:fixed;bottom:8px;left:8px;z-index:2147483647;background:#1B6B4A;color:#fff;font:12px/1.2 system-ui,sans-serif;padding:4px 8px;border-radius:6px;opacity:.9;pointer-events:none";
  document.documentElement.appendChild(badge);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
